import { loadUTMInfo, saveUTMInfo } from "@/feature-analytics/actions.mjs";
import { devError } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";
import { fetchCountryCode } from "@/util/use-country-code.mjs";

const env = { meta: null, promise: null };
const utmTags = [
  "utm_medium",
  "utm_source",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
];

export function setup() {
  const p = (async () => {
    try {
      env.meta = {};
      await loadUTMInfo(env.meta);
      const params = new URLSearchParams(globals.location?.search);
      const needOverwrite = utmTags
        .map((tag) => params.has(tag))
        .reduce((a, v) => a || v, false);
      // if any tag appears in url params
      if (needOverwrite) {
        env.meta = {};
        utmTags.forEach((tag) => {
          const val = params.get(tag) || undefined;
          if (val) env.meta[tag] = val;
        });
        saveUTMInfo(env.meta);
      }
      // UTM info is more important than country code
      // load them in serial instead of in parallel
      const countryCode = await fetchCountryCode({ skipSafetyCheck: true });
      env.meta.ipLocation = { country_code: countryCode };
      return true;
    } catch (err) {
      devError("initUTMInfo failed", err);
      return false;
    }
  })();
  env.promise = p;
  return p;
}

export async function teardown() {
  await getUTMPromise();
  env.meta = null;
  env.promise = null;
}

export function getUTMInfo() {
  return env.meta;
}

export function getUTMPromise() {
  if (!env.promise) return Promise.reject(new Error("UTM not initialized"));
  return env.promise;
}
